import { Icon, type IconProps } from "../icon";

const PATHS = [
  "M16 15.9995H15V8.9995C15 8.4475 14.552 7.9995 14 7.9995H4C3.448 7.9995 3 8.4475 3 8.9995V15.9995H2V6.5535L9 2.1785L16 6.5535V15.9995ZM5 15.9995H13V13.9995H5V15.9995ZM5 11.9995H13V9.9995H5V11.9995ZM9.53 0.1515C9.206 -0.0505 8.794 -0.0505 8.47 0.1515L0.47 5.1515C0.178 5.3345 0 5.6545 0 5.9995V16.9995C0 17.5515 0.448 17.9995 1 17.9995H17C17.552 17.9995 18 17.5515 18 16.9995V5.9995C18 5.6545 17.822 5.3345 17.53 5.1515L9.53 0.1515Z",
];

export function ManageAdsIcon(props: IconProps) {
  return <Icon paths={PATHS} {...props} />;
}
